import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BackendApiService } from '../../../services/backend-api.service';

/** Config passed when opening the picker:
 *   dialog.open(ReservationPickerComponent, { data: { moduleId: 19 } })
 * Closes with the picked reservation ({ reservationId, originalNumber,
 * counterValue }), or undefined if the user closed it without picking one. */
export interface ReservationPickerData {
  moduleId: number;
  /** The proposal being converted, if any — lets the backend compute each
   * reservation's live `preview_number` (Sales Rep Code recalculated against
   * THIS proposal's current sales rep) instead of showing the stale
   * `original_number` copied from whatever past job released the counter. */
  proposalId?: number;
}

@Component({
    selector: 'app-reservation-picker',
    templateUrl: './reservation-picker.component.html',
    styleUrls: ['./reservation-picker.component.scss'],
    standalone: false
})
export class ReservationPickerComponent implements OnInit {
  moduleId!: number;
  isLoading = true;
  reservations: any[] = [];

  proposalId?: number;

  constructor(
    public dialogRef: MatDialogRef<ReservationPickerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReservationPickerData,
    private backendApiService: BackendApiService
  ) {
    this.moduleId = this.data?.moduleId;
    this.proposalId = this.data?.proposalId;
  }

  ngOnInit(): void {
    const params: any = this.proposalId ? { proposal_id: this.proposalId } : {};
    this.backendApiService
      .getApi('series/module/' + this.moduleId + '/reservations/available', params, false)
      .subscribe({
        next: (result: any) => {
          this.reservations = result?.data?.reservations || result?.reservations || [];
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }

  /** The number to actually show for a row — live-recomputed preview when the
   * backend could produce one, otherwise the old frozen label as before. */
  displayNumber(reservation: any): string {
    return reservation.preview_number || reservation.original_number;
  }

  pick(reservation: any): void {
    this.dialogRef.close({
      reservationId: reservation.id,
      originalNumber: reservation.original_number,
      previewNumber: this.displayNumber(reservation),
      counterValue: reservation.counter_value,
    });
  }

  close(): void {
    this.dialogRef.close(undefined);
  }
}
